import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging, deleteToken } from 'firebase/messaging';
import { environment } from '../../../environments/environment.development';

@Injectable({ providedIn: 'root' })
export class FirebaseInitService {
  messaging!: Messaging;

  constructor() {
    const app = initializeApp(environment.firebase); // 🔥 Manual init
    this.messaging = getMessaging(app);
  }
  /**
   * ✅ Get FCM token using custom service worker with custom scope
   */
  async getFCMToken(): Promise<string | null> {
    // 👉 Register your custom SW explicitly with scope
    const registration = await navigator.serviceWorker.register(
      '/eligibility/firebase-messaging-sw.js',
      { scope: '/eligibility/' }
    );

    // 👉 Pass that registration to getToken
    return getToken(this.messaging, {
      vapidKey: environment.firebase.vapidKey,
      serviceWorkerRegistration: registration
    });
  }
  /* getFCMToken(): Promise<string | null> {
    return getToken(this.messaging, {
      vapidKey: environment.firebase.vapidKey
    });
  } */
  async deleteFCMToken(): Promise<boolean> {
    try {
      const result = await deleteToken(this.messaging);
      return result; // true if deleted, false if no token existed
    } catch (error) {
      console.error('Error deleting FCM token:', error);
      return false;
    }
  }
  onForegroundMessage(callback: (payload: any) => void): void {
    onMessage(this.messaging, callback);
  }
}
